import { useCallback } from 'react';

import { UPGRADE_DIALOG_ACTIONS_ORIGIN } from 'src/data/common';
import { FEATURE_LIMITS } from 'src/data/featureLimits';
import { closedPerformancePredictionsBannerTimestamp } from 'src/lib/localData';
import { useUiActions } from 'src/store';
import { useUpgradePopup } from 'src/views/UpgradePopup';

import { useTrackingEvents } from './services';

export const useHandlers = () => {
  const uiActions = useUiActions();
  const trackingEvents = useTrackingEvents();

  const openUpgradePopup = useUpgradePopup({
    actionsOrigin: UPGRADE_DIALOG_ACTIONS_ORIGIN.performancePredictionsBanner,
  });

  const handleUpgrade = useCallback(() => {
    trackingEvents.trackUpgradeClicked();

    openUpgradePopup(FEATURE_LIMITS.performancePredictions);
  }, [trackingEvents, openUpgradePopup]);

  const handleClose = useCallback(() => {
    trackingEvents.trackCloseClicked();

    closedPerformancePredictionsBannerTimestamp.write(Date.now());
    uiActions.setShowPerformancePredictionsBanner(false);
  }, [trackingEvents, uiActions]);

  return { handleUpgrade, handleClose };
};
